import React from 'react';
import { 
  SunIcon, 
  MoonIcon
} from '@heroicons/react/24/outline';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeSwitcher: React.FC = () => {
  const { theme, setTheme, actualTheme } = useTheme();

  const themes = [
    {
      value: 'light' as const,
      icon: SunIcon,
      label: 'Light mode'
    },
    {
      value: 'dark' as const,
      icon: MoonIcon,
      label: 'Dark mode'
    }
  ];

  const currentTheme = themes.find(t => t.value === theme);
  const currentIndex = themes.findIndex(t => t.value === theme);

  const handleThemeToggle = () => {
    const nextIndex = (currentIndex + 1) % themes.length;
    setTheme(themes[nextIndex].value);
  };

  return (
    <button
      onClick={handleThemeToggle}
      className={`p-2 rounded-2xl backdrop-blur-sm border transition-all duration-300 hover-magnify-sm modern-focus shadow-sm hover:shadow-lg ${
        actualTheme === 'dark' 
          ? 'bg-gradient-to-r from-slate-800/90 to-slate-700/90 border-slate-600/30 hover:from-slate-700/90 hover:to-slate-600/90 shadow-slate-900/20' 
          : 'bg-white/90 border-neutral-200/50 hover:bg-white'
      }`}
      aria-label={currentTheme?.label || 'Theme switcher'}
      title={currentTheme?.label || 'Theme switcher'}
    >
      {currentTheme && (
        <currentTheme.icon className={`h-5 w-5 transition-all duration-300 ${actualTheme === 'dark' ? 'text-slate-300' : 'text-neutral-600'}`} />
      )}
    </button>
  );
};

export default ThemeSwitcher;
